import React from 'react'
import { SelfRegistrationModal } from './base-modal'
import {
  Typography,
  Divider,
  Box,
  Checkbox,
  FormControlLabel,
  Link
} from '@mui/material'
import { useStyles } from '../style'
import { SelfRegistrationToggle } from '../toggle'

export const SelfRegistrationSuccessModal = ({
  open,
  tenant,
  handleClose,
  id
}) => {
  const classes = useStyles()
  const [show, setShow] = React.useState(false)

  const handleModalClose = () => {
    handleClose()

    show && localStorage.setItem(id, 'no')
  }

  return (
    <SelfRegistrationModal
      id={id}
      open={open}
      header={
        <>
          <Typography variant='h6'>Domain List Saved Successfully</Typography>
          <Divider className={classes.divider} />
        </>
      }
      body={
        <>
          <Typography marginBottom={3}>
            You have successfully saved the list of approved domains. This
            action activates the domain-restricted self-registration feature,
            allowing users with email addresses from the specified domains to
            register themselves.
          </Typography>
          <Typography marginBottom={3}>
            <strong>Remember:</strong> You can always disable this feature or
            edit the list at any moment to control user access and security
            preferences.
          </Typography>

          <Box marginBottom={3}>
            <SelfRegistrationToggle tenant={tenant} />
          </Box>

          <Typography marginBottom={3}>
            <strong>Note:</strong> Users from the domain you remove will still
            be able to log in
          </Typography>

          <Box marginBottom={3}>
            <FormControlLabel
              control={
                <Checkbox
                  data-test={`${id}-checkbox`}
                  value={show}
                  onChange={() => setShow((state) => !state)}
                />
              }
              label="Don't show this message again"
            />
          </Box>
        </>
      }
      footer={
        <Box className={classes.modalFooterActions}>
          <Link
            underline='hover'
            data-test={`${id}-close-btn`}
            onClick={handleModalClose}
            className={classes.modalFooterBtn}
          >
            Close
          </Link>
        </Box>
      }
      handleClose={handleClose}
    />
  )
}
